module.exports = __webpack_public_path__ + "img/portraits_29_V.0d06edaa.webp";